export const BUSINESS = {
    name: "Jassi Wood Works",
    tagline: "Bespoke woodcraft, built to last generations",
    phone: "+91 98765 43210",
    whatsapp: "919876543210", // digits only for wa.me link
    email: "hello@jassiwoodworks.com",
    address: "Plot 12, Industrial Area, Phase 1, Mohali, Punjab 160055, India",
    mapsQuery: "Industrial+Area+Phase+1+Mohali+Punjab",
    instagram: "https://instagram.com/jassiwoodworks",
    facebook: "https://facebook.com/jassiwoodworks",
    youtube: "https://youtube.com/@jassiwoodworks",
};

export const CATEGORIES = [
    { value: "all", label: "All Work" },
    { value: "custom_furniture", label: "Custom Furniture" },
    { value: "modular_kitchens", label: "Modular Kitchens" },
    { value: "wooden_doors", label: "Wooden Doors" },
    { value: "wardrobes", label: "Wardrobes" },
    { value: "interior_woodwork", label: "Interior Woodwork" },
];

export const SERVICES = [
    {
        slug: "custom-furniture",
        title: "Custom Furniture",
        body: "From a single heirloom dining table to a full suite — solid wood, traditional joinery, hand-finished.",
        image: "https://images.unsplash.com/photo-1597072689227-8882273e8f6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwd29vZGVuJTIwZnVybml0dXJlfGVufDB8fHx8MTc4MTE3NzQ5NXww&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "modular-kitchen",
        title: "Modular Kitchen Design",
        body: "Floor-to-ceiling kitchen cabinetry in teak, oak, and engineered finishes — designed around how you cook.",
        image: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3b29kZW4lMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxMTc3NDk1fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "doors-windows",
        title: "Wooden Doors & Windows",
        body: "Carved entrance doors, pivot doors, French windows — sheesham, teak and reclaimed timber.",
        image: "https://images.pexels.com/photos/8134755/pexels-photo-8134755.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        slug: "interior-woodwork",
        title: "Home Interior Woodwork",
        body: "Wall paneling, ceiling work, staircases, TV units — designed and site-installed by our own team.",
        image: "https://images.unsplash.com/photo-1487015307662-6ce6210680f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwd29vZGVuJTIwZnVybml0dXJlfGVufDB8fHx8MTc4MTE3NzQ5NXww&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "office-commercial",
        title: "Office & Commercial Woodwork",
        body: "Reception desks, conference tables, retail fixtures — quietly premium environments for your brand.",
        image: "https://images.unsplash.com/photo-1653971858625-9cb23d0dca80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwd29vZGVuJTIwZnVybml0dXJlfGVufDB8fHx8MTc4MTE3NzQ5NXww&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "restoration",
        title: "Wood Restoration & Polishing",
        body: "Bring heritage pieces and tired surfaces back to life with traditional French polishing and restoration.",
        image: "https://images.unsplash.com/photo-1611021061285-16c871740efa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx3b29kd29ya2luZyUyMGNyYWZ0c21hbnxlbnwwfHx8fDE3ODExNzc0OTV8MA&ixlib=rb-4.1.0&q=85",
    },
];

export const TESTIMONIALS = [
    { name: "Priya & Rohan Mehta", role: "Homeowners, Chandigarh", quote: "Jassi's team turned a half-formed Pinterest board into the kitchen of our dreams. The quality of the joinery is unreal — it feels like a heirloom already." },
    { name: "Arvinder Singh", role: "Interior Designer", quote: "I've worked with a dozen carpenters across north India. None match the precision and finish that Jassi Wood Works delivers, project after project." },
    { name: "Neha Kapoor", role: "Director, Lumen Architects", quote: "From spec to installation, they take complete ownership. We now spec them as our preferred millwork partner for premium residential projects." },
];

export const youtubeEmbed = (url) => {
    if (!url) return "";
    if (url.includes("/embed/")) return url;
    const idMatch = url.match(/(?:v=|youtu\.be\/|\/embed\/)([\w-]{11})/);
    if (idMatch) return `https://www.youtube.com/embed/${idMatch[1]}`;
    return url;
};
